import { Trans } from 'react-i18next'
import * as S from './styled'

export const CybersecurityBanner = () => (
  <S.Banner>
    <S.BannerText>
      <Trans
        i18nKey="trusted_by_banner"
        components={{
          b: <S.BannerHighlight />,
        }}
      />
    </S.BannerText>
  </S.Banner>
)
